import React, { useState } from "react";
import { useTemplateStore } from "@/zustand/templateStore";
import s from "@/components/Inputs/Input.module.scss";
import cn from "@/utils/classNames.js";

const CardCvv = ({
  dataTestId,
  placeholder,
  error,
  name,
  width,
  value,
  margin,
  icon,
  min,
  max,
  comment,
  setValue,
  submitCount,
  register,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { isMobile } = useTemplateStore();
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

  return (
    <div
      className={s.inputContainer}
      style={{
        width: width == "full" ? "100%" : `calc(${width == "half" ? 50 : width}% - 6px)`,
        marginRight: margin ? "12px" : "0px",
        backgroundColor: "transparent",
      }}
    >
      <div
        className={cn(
          s.input,
          s.input__text,
          error && s.input__error,
          isEnhancedContrast && s.enhancedContrast,
          isEnhancedContrast && error && s.enhancedContrast__error
        )}
      >
        <input
          data-testid={dataTestId}
          maxLength={max}
          minLength={min}
          type="tel"
          autoComplete="cc-csc"
          className={s.styledInput}
          name={name}
          value={value}
          {...register(name)}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/[^0-9]/g, "");
            setValue(name, numericValue, {
              shouldValidate: true,
              shouldTouch: true,
            });
          }}
        />
        <label
          className={cn(
            s.styledLabel,
            s.cvv,
            value?.length > 0 && s.styledLabel__active,
            isEnhancedContrast && s.styledLabel__enhancedContrast
          )}
        >
          {placeholder}
        </label>

        {icon && (
          <div
            className={s.input__helper}
            onClick={() => {
              if (isMobile) {
                setIsVisible(!isVisible);
              }
            }}
          >
            <div
              className={s["input__img--alt"]}
              style={{
                backgroundImage: `url(${icon}`,
              }}
            />

            {comment && (
              <span className={s.input__comment} visible={isVisible.toString()}>
                {comment}
              </span>
            )}
          </div>
        )}
      </div>
      {error && <span className={s.formError}>{error}</span>}
    </div>
  );
};

export default CardCvv;
